// extracted by mini-css-extract-plugin
module.exports = {"AnswersList":"AnswersList_AnswersList__3lGaY"};